<template>
	
<div class="form">

	<com-input v-for="(input, index) in inputs" :input="input" :key="index" />

	<com-foot v-if="isValid" :custom="true" v-on:next="$emit('next')" />

</div>

</template>

<script>

import comInput from '@/components/tool/common/section/form/Input'
import comFoot from '@/components/tool/common/section/Foot'

export default {

	props: ['section'],

	components: {
		'com-input': comInput,
		'com-foot': comFoot
	},

	computed: {

		values: function() {

			return {
				treatment: this.getValue('aid.treatment'),
				feeling: this.getValue('aid.feeling'),
				benefits: {
					chance: this.getValue('aid.benefits.chance'),
					independance: this.getValue('aid.benefits.independance'),
					strength: this.getValue('aid.benefits.strength')
				},
				concerns: {
					longterm: this.getValue('aid.concerns.longterm'),
					sideeffects: this.getValue('aid.concerns.sideeffects')
				},
				next: {
					prescription: this.getValue('aid.next.prescription'),
					timeline: this.getValue('aid.next.timeline'),
					text: this.getValue('aid.next.text'),
				},
				supplements: {
					recommended: this.getValue('aid.supplements.recommended'),
					action: this.getValue('aid.supplements.action')
				},
				followup: {
					accept: this.getValue('aid.followup.accept'),
					action: this.getValue('aid.followup.action'),
					timeline: this.getValue('aid.followup.timeline'),
					check: this.getValue('aid.followup.check'),
				},
				text: this.getValue('aid.text')
			}

		},

		isValid: function() {

			return (
				this.values.treatment !== null &&
				this.values.feeling && 
				this.values.next.prescription &&
				(
					this.values.next.timeline 
					||
					this.values.next.prescription === 4
					||
					this.values.next.prescription === 3
					||
					this.values.feeling === 3
				) &&
				this.values.supplements.recommended !== null && 
				this.values.benefits.chance &&
				this.values.benefits.independance &&
				this.values.benefits.strength &&
				this.values.concerns.longterm &&
				this.values.concerns.sideeffects &&
				(
					!this.values.supplements.recommended  
					||
					this.values.supplements.action
				) &&
				(
					(
						this.values.followup.accept === 1
						&& 
						this.values.followup.action
						&&
						this.values.followup.timeline
					)
					||
					(
						this.values.followup.accept === 2
					)

				)
			)

		},

		inputs: function() {

			var inputs = []

			var treatments = []

			this.$_.each(this.$store.getters['logic/variable'](this.$store.getters['data/setup'].treatments.variable), function(id) {

				this.$_.each(this.$store.getters['data/setup'].treatments.options, function(treatment) {

					if (treatment.id === id) treatments.push({id: id, value: id, text: treatment.name})

				}.bind(this))

			}.bind(this))

			inputs.push(this.createInput({
				type: this.$constants.input.type.scale,
				text: {
					label: 'How important are these medicine benefits to you...',
					columns: [
						'Not at all', 'Slightly', 'Moderately', 'Very', 'Extremely'
					]
				},
				layout: {
					stacked: true
				},
				variables: [
					{
						id: this.$store.getters['logic/variable/named']['aid.benefits.strength'],
						text: 'Strengthening bone'
					},
					{
						id: this.$store.getters['logic/variable/named']['aid.benefits.chance'],
						text: 'Lowering the chance of future fractures and protecting the spine'
					},
					{
						id: this.$store.getters['logic/variable/named']['aid.benefits.independance'],
						text: 'Maintaining independence '
					}
				]
			}))

			inputs.push(this.createInput({
				type: this.$constants.input.type.scale,
				text: {
					label: 'How likely is it that you would be put off taking this medicine because of concerns about…',
					columns: [
						'Not at all', 'Slightly', 'Moderately', 'Very', 'Extremely'
					]
				},
				layout: {
					stacked: true
				},
				variables: [
					{
						id: this.$store.getters['logic/variable/named']['aid.concerns.longterm'],
						text: 'Rare long-term issues with medicines such as jaw bone problems 	'
					},
					{
						id: this.$store.getters['logic/variable/named']['aid.concerns.sideeffects'],
						text: 'Common side-effects with medicines such as indigestion and reflux'
					}
				]
			}))

			inputs.push(this.createInput({
				variable: this.$store.getters['logic/variable/named']['aid.treatment'],
				type: this.$constants.input.type.select,
				text: {
					label: this.section.form.treatment.label
				},
				options: treatments
			}))

			inputs.push(this.createInput({
				variable: this.$store.getters['logic/variable/named']['aid.feeling'],
				type: this.$constants.input.type.toggle,
				layout: {
					stacked: 1
				},
				options: [
					{id: 1, value: 1, text: "I am willing to take the medicine"},
					{id: 2, value: 2, text: "I am not sure about taking the medicine"},
					{id: 3, value: 3, text: "I prefer not to take the medicine"}
				]
			}))

			inputs.push(this.createInput({
				variable: this.$store.getters['logic/variable/named']['aid.next.prescription'],
				type: this.$constants.input.type.select,
				text: {
					label: 'Your prescription...'
				},
				options: [
					{id: 1, value: 1, text: 'GP will issue your prescription / provide your medicine'},
					{id: 2, value: 2, text: 'Hospital will provide your medicine'},
					{id: 3, value: 3, text: 'You prefer not to have a prescription / receive a medicine'},
					{id: 4, value: 4, text: 'Other'}
				]
			}))

			if (this.getValue('aid.next.prescription') === 1 || this.getValue('aid.next.prescription') === 2) {

				inputs.push(this.createInput({
					variable: this.$store.getters['logic/variable/named']['aid.next.timeline'],
					type: this.$constants.input.type.select,
					text: {
						label: (this.getValue('aid.next.prescription') === 1) ? 'You should contact your GP in...' : 'You should expect to hear from your hospital in...'
					},
					options: [
						{id: 1, value: 1, text: '1 week'},
						{id: 2, value: 2, text: '2 weeks'},
						{id: 3, value: 3, text: '3 weeks'},
						{id: 4, value: 4, text: '4 weeks'},
						{id: 5, value: 5, text: '5 weeks'},
						{id: 6, value: 6, text: '6 weeks'},
						{id: 7, value: 7, text: 'Other'},
					]
				}))

				if (this.getValue('aid.next.timeline') === 7) {

					inputs.push(this.createInput({
						variable: this.$store.getters['logic/variable/named']['aid.next.text'],
						type: this.$constants.input.type.textbox,
						numeric: true,
						text: {
							label: ' ',
							placeholder: '0',
							suffix: 'weeks'
						}
					}))

				}

			}

			if (this.getValue('aid.next.prescription') === 4) {

				inputs.push(this.createInput({
					variable: this.$store.getters['logic/variable/named']['aid.next.text'],
					type: this.$constants.input.type.textbox,
					layout: {
						lines: 5,
						stacked: 1
					},
					text: {
						label: this.section.form.next.other
					}
				}))

			}	

			inputs.push(this.createInput({
				variable: this.$store.getters['logic/variable/named']['aid.supplements.recommended'],
				type: this.$constants.input.type.toggle,
				text: {
					label: 'You have been recommended to take supplements...'
				},
				options: [
					{id: 1, value: 1, text: 'Yes'},
					{id: 2, value: 0, text: 'No'}
				]
			}))

			if (this.getValue('aid.supplements.recommended') === 1) {

				inputs.push(this.createInput({
					variable: this.$store.getters['logic/variable/named']['aid.supplements.action'],
					type: this.$constants.input.type.select,
					text: {
						label: 'It is recommended that...'
					},
					options: [
						{id: 1, value: 1, text: 'Your GP prescribe calcium supplements'},
						{id: 2, value: 2, text: 'Your GP prescribe calcium and vitamin D supplements'},
						{id: 3, value: 3, text: 'Your GP prescribe Vitamin D supplements'},
						{id: 4, value: 4, text: 'You take over the counter calcium supplements'},
						{id: 5, value: 5, text: 'You take over the counter calcium and vitamin D supplements'},
						{id: 6, value: 6, text: 'You take over the counter Vitamin D supplements'}
					]
				}))
			
			}

			inputs.push(this.createInput({
				variable: this.$store.getters['logic/variable/named']['aid.followup.accept'],
				type: this.$constants.input.type.toggle,
				text: {
					label: 'The Fracture Liaison Service team will follow up with you'
				},
				options: [
					{id: 1, value: 1, text: 'Yes'},
					{id: 2, value: 2, text: 'No'}
				]
			}))

			if (this.getValue('aid.followup.accept') === 1) {

				inputs.push(this.createInput({
					variable: this.$store.getters['logic/variable/named']['aid.followup.action'],
					type: this.$constants.input.type.select,
					text: {
						label: 'You will be followed up'
					},
					options: [
						{id: 1, value: 1, text: 'By Phone'},
						{id: 2, value: 2, text: 'By Letter'},
						{id: 3, value: 3, text: 'By Email'},
						{id: 4, value: 4, text: 'By Text'},
						{id: 5, value: 5, text: 'In person'}
					]
				}))

				inputs.push(this.createInput({
					variable: this.$store.getters['logic/variable/named']['aid.followup.timeline'],
					type: this.$constants.input.type.textbox,
					numeric: true,
					text: {
						label: 'You will be followed up in',
						placeholder: '0',
						suffix: 'weeks'
					}
				}))
			
			}

			if (this.getValue('aid.followup.accept') === 2) {

				inputs.push(this.createInput({
					variable: this.$store.getters['logic/variable/named']['aid.followup.check'],
					type: this.$constants.input.type.toggle,
					text: {
						label: 'If you have any side-effects or issues you should:'
					},
					multiple: {
						enabled: 1
					},
					options: [
						{id: 1, value: 1, text: 'Contact your GP'},
						{id: 2, value: 2, text: 'Contact the Fracture Liaison Service'}
					]
				}))
			
			}
			
			inputs.push(this.createInput({
				variable: this.$store.getters['logic/variable/named']['aid.text'],
				type: this.$constants.input.type.textbox,
				layout: {
					lines: 5,
					stacked: 1
				},
				text: {
					label: this.section.form.other
				}
			}))

			return inputs

		}

	},

	methods: {

		getValue: function(name) {

			return this.$store.getters['logic/variable'](this.$store.getters['logic/variable/named'][name])

		},

		packageOptions: function(options) {

			var packaged = []

			this.$_.each(options, function(option, index) {

				packaged.push({
					id: index + 1,
					value: index + 1,
					text: option
				})

			})

			return packaged

		}

	}
	
}

</script>

<style scoped>

</style>